
import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import Button from 'reactstrap/lib/Button';
import InputFeild from 'reactstrap/lib/Input';
import { auth as Auth } from '../../../actions/auth';
import CONSTANTS from '../../../constant';
import moment from 'moment';
import { downloadApiFile } from '../../../actions';
import { setError, setLoader } from '../../../actions/action-creator';
import store from '../../../store';
import PartnerPersonalDetails from './personal_details';
import PartnerDocuments from './documents';
import PartnerBankDetails from './bank_details';

class PartnerProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: this.props.selectedTab || 0
        };
    }


    componentDidMount() {
      
    }


    selectTab = (tabId) => {
        if(tabId === 0) this.props.history.push("/partner/profile"); 
        if(tabId === 1) this.props.history.push("/partner/profile/doc"); 
        if(tabId === 2) this.props.history.push("/partner/profile/bank"); 

        this.setState({selectedTab: tabId});
    }

    render() {
        let user = store.getState().user;
        let { } = this.props;
        let { selectedTab } = this.state;

        return (

            <>
                <h4 className='mt-2 mb-3'>Profile Details</h4>
                <Row className="mt-0">
                    {["Personal Details", "KYC Details", "Payout Details"].map((tab, i) =>
                    <Col xs={12} md="auto" key={i} className="">
                        <div style={{borderRadius: 18, cursor: "pointer", background: selectedTab === i ? "#4a58d545" : "#f8f9fa"}} className='px-4 py-2 border font-weight-bold' onClick={() => this.selectTab(i)}>{tab}</div>
                    </Col>
                    )}
                </Row>
                <div className='p-3 my-4'>
                    {selectedTab === 0 && <PartnerPersonalDetails />}
                    {selectedTab === 1 && <PartnerDocuments />}
                    {selectedTab === 2 && <PartnerBankDetails />}
                </div>

                {!!user && !!user.documents && !!user.documents.gst ?
                    <span style={{position: "fixed", bottom: 10, right: 10}}>*Payouts will be processed on a monthly basis based on submitted invoices.</span>
                    :
                    <span style={{position: "fixed", bottom: 10, right: 10}}>{/* *Weekly payouts are credited directly to your bank account every Thursday. */}</span>
                }
            </>

        );
    }
}

export default PartnerProfile;
